export default {
    methods: {
        getInterpretationType: function (documents, operations){

            if(documents.length == 1 && operations.length == 1){
                return 'one_document_to_one_operation';
            }
            else if(documents.length == 1 && operations.length >= 2){
                return 'one_document_to_multiple_operations';
            }
            else if(documents.length >= 2 && operations.length == 1){
                return 'one_operation_to_multiple_documents';
            }
            else if(documents.length == 0 && operations.length >= 2){
                return 'one_operation_to_one_or_many_operations';
            }
            else if(documents.length >= 2 && operations.length == 0){
                return 'one_document_to_one_or_many_documents';
            }
            return '';
        }
    },
};
